import {numToChinanumerals} from "chinesenum";

export function numberToWordsChinese(num: number) {
    return numToChinanumerals(num);
}